import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import markup from "ulysses/widgets/timeline/timeline.html";
import mk_chat_base from "ulysses/widgets/timeline/chat-base.html";
import mk_chat_email_in from "ulysses/widgets/timeline/chat-email-in.html";
import mk_chat_email_out from "ulysses/widgets/timeline/chat-email-out.html";
import mk_chat_timer from "ulysses/widgets/timeline/chat-timer.html";
import mk_doc from "ulysses/widgets/timeline/chat-document.html";
import mk_act from "ulysses/widgets/timeline/chat-action-taken.html";
import mk_attach from "ulysses/widgets/timeline/chat-attachment.html";
import mk_chatbot from "ulysses/widgets/timeline/chat-chatbot-conversation.html";
import mk_editor from "ulysses/widgets/timeline/editor.html";
import "ulysses/widgets";

var markupDef = Promise.Deferred();
$(document).ready(function() {
    $(markup+mk_chat_base+mk_chat_email_in+mk_chat_email_out+mk_chat_timer+mk_doc+mk_act+mk_attach+mk_chatbot+mk_editor).appendTo($("body"));
    markupDef.resolve();
});
function edit_timeline_settings(settings) {
    var res = Promise.Deferred();
    var cdata = $.extend({ "filter": null, "title": _("timeline_title_timeline", "Timeline"), "show_children":false, "global": false, "default_mode": "all"}, ko.toJS(settings));
    var dialog = uly.dialogs.execute($("#timeline-editor").html(), {
        "title":_("timeline_title_edit_timeline_configuration", "Edit Timeline Configuration")
    }, cdata).done(function([result]) {
        res.resolve({
            "show_children":ko.unwrap(result.show_children) || false,
            "global": ko.unwrap(result.global) || false,
            "title": ko.unwrap(result.title) || _("timeline_edit_timeline_settings_timeline", "Timeline"),
            "filter": ko.unwrap(result.filter) || null,
            "default_mode": ko.unwrap(result.default_mode) || "all"
        });
    }).fail(res.reject);
    return res.promise();
}

ko.bindingHandlers.sidebartimeline = {
    init: function(elt, va, bindings, model, context) {

        var timeline_data = {
            "entity": ko.pureComputed(function() { return null; }),
            "editor":{
                "note":ko.observable(null),
                "type_id":ko.observable(null),
                "show_hidden":ko.observable(false),
                "show_children": ko.pureComputed(function() { return false; }),
                "global": ko.pureComputed(function() { return true; }),
                "toggle_visible":function() { timeline_data.editor.show_hidden(!timeline_data.editor.show_hidden()); },
                "filter": ko.pureComputed(function() { return "NOT author_id:me"; }),
                "default_mode": ko.observable("all")
            },
            "title": ko.pureComputed(function() { return _("timeline_recent_activity", "Recent Activity"); })
        };
        var childContext = context.createChildContext(timeline_data);
        markupDef.then(function() {
            ko.applyBindingsToDescendants(childContext, elt);
        });
        return { controlsDescendantBindings: true };
    }
};

ko.bindingHandlers.sidebarentitytimeline = {
    init: function(elt, va, bindings, model, context) {

        var timeline_data = {
            "entity": ko.pureComputed(function() { return ko.unwrap(va()); }),
            "editor":{
                "note":ko.observable(null),
                "type_id":ko.observable(null),
                "show_hidden":ko.observable(false),
                "show_children": ko.pureComputed(function() { return false; }),
                "global": ko.pureComputed(function() { return false; }),
                "toggle_visible":function() { timeline_data.editor.show_hidden(!timeline_data.editor.show_hidden()); },
                "filter": ko.pureComputed(function() { return null; }),
                "default_mode": ko.observable("all")
            },
            "title": ko.pureComputed(function() { return _("timeline_timeline", "Timeline"); })
        };
        var childContext = context.createChildContext(timeline_data);
        ko.applyBindingsToDescendants(childContext, elt);
        return { controlsDescendantBindings: true };
    }
};

ko.bindingHandlers.timeline_widget = {
    init: function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.title("<h3 class='box-title'>{0}</h3>".format(_("timeline_loading", "Loading...")));
        widget_model.icon("fa fa-clock-o");


        var default_note_type = ko.unwrap(bindings().default_note_type);

        var settings = ko.unwrap(widget_model.settings);
        var timeline_data = {
            "entity": ko.pureComputed(function() { return uly.utils.get_bound_resource(elt); }),
            "editor":{
                "note":ko.observable(null),
                "type_id":ko.observable(default_note_type || null),
                "show_hidden":ko.observable(settings.show_hidden || false),
                "show_children": ko.pureComputed(function() { return ko.unwrap(widget_model.settings).show_children || false; }),
                "global": ko.pureComputed(function() { return ko.unwrap(widget_model.settings).global || false; }),
                "toggle_visible":function() { timeline_data.editor.show_hidden(!timeline_data.editor.show_hidden()); },
                "filter": ko.pureComputed(function() { return ko.unwrap(widget_model.settings).filter || null; }),
                "default_mode":  ko.pureComputed(function() { return ko.unwrap(widget_model.settings).default_mode || "all"; })
            },
            "title": ko.pureComputed(function() { return ko.unwrap(widget_model.settings).title || _("timeline_timeline", "Timeline"); })
        };
        $(elt).data("timeline_model", timeline_data);

        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("timeline_caption_modify", "Modify"),
            "icon":"fa-edit",
            "action":function(e){
                var settings = ko.unwrap(widget_model.settings);
                edit_timeline_settings(settings).done(function(result) {
                    var new_settings = $.extend({}, settings, {
                        show_children: result.show_children,
                        filter: result.filter,
                        global: result.global,
                        title: result.title || _("timeline_timeline", "Timeline"),
                        default_mode: result.default_mode || "all"
                    });
                    widget_model.settings(new_settings);
                    uly.publish("page.savesettings");
                });
            },
            "colour":"primary",
            "permission": "editpage"
        });

        var childContext = context.createChildContext(timeline_data);
        ko.applyBindingsToDescendants(childContext, elt);
        return { controlsDescendantBindings: true };
    },
    update:function(elt, va, allbindings, model, context) {
        var timeline_model = $(elt).data("timeline_model");
        var settings = ko.unwrap(ko.unwrap(va()).settings);
        ko.unwrap(va()).title("<h3 class='box-title'>" + timeline_model.title() + "</h3>");
        uly.publish("widget.active", elt);
    }
};

uly.widgets.register({
    "type":"timeline_widget",
    "caption":_("timeline_caption_timeline", "Timeline"),
    "description":_("timeline_description_show_the_timeline_of_a_record", "Show the timeline of a record"),
    "icon":"fa-clock-o",
    "colour":"sienna",
    "init":function() {
        var data = { "show_children":ko.observable(false),
            "global":ko.observable(false),
            "title":ko.observable(_("timeline_timeline", "Timeline")),
            "filter": ko.observable(null),
            "default_mode": ko.observable("all")
        };
        var init_def = Promise.Deferred();
        init_def.resolve(ko.toJS(data));
        return init_def;
    },
    "actions":[{
        "caption":_("timeline_caption_settings", "Settings"),
        "icon":"fa-cog",
        "action":function(e){
            return false;
        },
        "colour":"default"
    }]
});

uly.actions.addentry = function(e, $elt, ui) {
    var new_entry = ko.toJS(ui.model);
    var new_note = new_entry.note;
    var new_type = ko.unwrap(new_entry.selected_type);
    var taken_type_id = ko.unwrap(new_entry.action_taken_type_id);
    var is_action = false;
    if (new_type) {
        is_action = ko.unwrap(new_type.key_code) == "action_taken";
        new_type = new_type.id;
    }
    is_action = is_action && taken_type_id;
    if (!new_note && !is_action) return;
    var resource = ko.unwrap(ui.context.$parent);
    if (!resource) {
        uly.utils.show_results({"success":false, "error":_("timeline_no_resource_found", "Cannot create a new entry for this record.")});
        return;
    }
    new HalResource(resource).post("uly:timeline", 
        { 
            "note": new_note, 
            "type_id":new_type || "note",
            "action_taken_type_id": taken_type_id
        }).then(function(result) {
        ui.model.note(null);
        if (result.inserted) {
            uly.publish("timeline.inserted." + resource.unique_id, result.inserted);
        }
        //uly.publish("entity.modified", resource);
        return result;
    }).always(uly.utils.show_results );
};

var _cached_types = null;
function get_note_types() {
    var res = Promise.Deferred();
    if (_cached_types) {
        res.resolve(_cached_types);
    } else {
        uly.api.start()
            .follow("uly:data")
            .follow("uly:journalentrytype", {nodata:1})
            .follow("uly:lookup", {body:1})
            .then(function(data) {
                _cached_types = data.items;
                res.resolve(_cached_types);
            }, function(error) { res.reject(error); });
    }
    return res;
}

ko.bindingHandlers.with_timeline = {
    init: function(elt, va, allbindings, model, context) {
        var data = ko.unwrap(va());
        data.note = ko.observable(null);
        data.note_types = ko.observableArray([]);
        data.selected_type = ko.observable(null);
        data.action_taken_type_id = ko.observable(null);
        data.action_taken_type = {
            id: ko.observable(null),
            key_code: ko.observable(null),
            name: ko.observable(null)
        };
        data.select_note_type = function(val) {
            data.selected_type(val);
            if (val.body && !data.note()) {
                data.note(val.body);
            }
        };
        get_note_types().then(function(types) {
            data.note_types(types);
            if (!data.selected_type()) {
                var note = types.filter(function(t) { return t.key_code == "note";})[0];
                data.selected_type(note || types[0]);
            }
        });
        var childContext = context.createChildContext(data);
        ko.applyBindingsToDescendants(childContext, elt);
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.with_timeline = true;
